
import { RevCard } from '@ds/components/Card'

import { PaymentAdvertisement } from '@payment'

export default {
  components: {
    PaymentAdvertisement,
    RevCard,
  },
}
